import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { RequestStatus } from '../../../../../../common/enums/requestStatus';
import { translateKey } from '../../../../../translate';
import { UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProfileImageWithName } from '../../../episodes/common';
import { Icd10SelectionsRead } from '../../utils/v1/Icd10/Icd10SelectionsRead';
import { ProfileImages } from '../../utils/v1/ProfileImages';
import { ServiceConsumerSupervisorRead } from '../../utils/v1/ServiceConsumerSupervisorRead';

export function GtcV1RequestSummary(props: ICustomControlRequestReadProps) {
    const question =
        props.request.customControlData && props.request.customControlData.vraag
            ? props.request.customControlData.vraag
            : props.request.question;

    return (
        <>
            {props.request.status !== RequestStatus.requested ? (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('request.sendTo')}</FormLabel>
                    <InputContainer>
                        <ProfileImageWithName
                            organization={props.request.recipientOrganization}
                            practitioner={props.request.recipientPractitioner}
                        />
                    </InputContainer>
                </HorizontalFormGroupRead>
            ) : (
                <ProfileImages request={props.request} />
            )}
            <ServiceConsumerSupervisorRead {...props} />

            <Icd10SelectionsRead
                diagnosis={props.request.diagnosis}
                diagnosisConclusion={props.request.customControlData?.conclusie_diagnose}
                hideTitle
                showWorkingDiagnosis
                thesaurusTermDate={props.request.dateSent}
            />

            {question && (
                <HorizontalFormGroupRead>
                    <FormLabel>Vraag</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{question}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
